class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');

    this.swatches();
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);

    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }

  swatches() {
    /*-----------------------------------------------------
      - Fetch a request to search using search.swatches.json
      - Render response
    -----------------------------------------------------*/
    var selectors = {
      container: 'swatches-container',
      colour: 'swatches-colour',
    }

    var cache = {}

    function cacheSelectors() {
      cache = {
        $container: document.getElementById(selectors.container),
        $colour: document.getElementById(selectors.colour),
      }
    }

    function fetchItemsByTitle(title) {
      fetch('/search?type=product&q=title:"'+ title +'"&view=swatches')
      .then(function (response) {
        return response.text();
      }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var swatchesHTML = doc.querySelector('#swatches');

        renderTemplate(swatchesHTML)
        addSelected()
      }).catch(function (err) {
        console.warn('Something went wrong.', err);
      });
    }

    function getProductTitle() {
      if( cache.$container.dataset.productTitle != undefined) {
          return cache.$container.dataset.productTitle
        }
    }

    function renderTemplate(template) {
      cache.$container.appendChild(template);
    }

    function addSelected() {
      var swatchColor = cache.$container.dataset.productSwatch;
      cache.$colour.innerHTML = swatchColor;

      var urlColor = cache.$container.dataset.productSwatch.toLowerCase().replaceAll(' /', '').replaceAll(' ', '-');
      var swatchEl = document.querySelectorAll('.swatch');
      swatchEl.forEach(swatch => {
        if (swatch.classList.contains(urlColor)) {
          swatch.classList.add('selected', 'tw-border-black');
        }
      });
    }

    cacheSelectors()
    fetchItemsByTitle(getProductTitle())
  }
}

customElements.define('product-form', ProductForm);
